<template>
    <div class="g-px g-mb">
        <div class="row-c-xl">
            <div class="grid-block">
                <div class="grid-block__nav">
                    <ul>
                        <li :key="index" v-for="(item, index) in content">
                            <a :class="{ 'active': activeBlock ===  `${item.label.replace(' ','')}` }"
                               :href="`#${item.label.replace(' ','')}`"
                               v-smooth-scroll
                            >{{item.label}}</a>
                        </li>
                    </ul>
                </div>
                <div class="grid-block__content">
                    <div class="left">
                        <div :data-name="`${card.label.replace(' ','')}`" :key="index"
                             class="card-wrapper card-wrapper--grid" v-for="(card, index) in firstColumnCards"
                             v-html="card.card">
                        </div>
                    </div>
                    <div class="right">
                        <div :data-name="`${card.label.replace(' ','')}`"
                             :key="index"
                             class="card-wrapper card-wrapper--grid"
                             v-for="(card, index) in secondColumnCards"
                             v-html="card.card"
                        >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                firstColumnCards: [],
                secondColumnCards: [],
                activeBlock: '',
            }
        },
        props: {
            content: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            handleScroll() {
                let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                const cards = document.querySelectorAll('.card-wrapper--grid');
                let closestCard = {
                    name: '',
                    distance: 0
                };
                cards.forEach(card => {
                    const distanceToTop = Math.abs(card.offsetTop - scrollTop);
                    if (distanceToTop < closestCard.distance || closestCard.distance === 0) {
                        closestCard.name = card.getAttribute('data-name');
                        closestCard.distance = distanceToTop;
                    }
                })
                this.activeBlock = closestCard.name;
            }
        },
        mounted() {
            for (let i = 0; i < this.content.length; i++) {
                i % 2 ?
                    this.secondColumnCards.push(this.content[i]) :
                    this.firstColumnCards.push(this.content[i])
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }
</script>